module.exports = __webpack_public_path__ + "static/media/RichardChanResume2025.6ba787f7.pdf";